"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SellerPriceDetailsEventActions = exports.PriceEventActions = exports.EventTypes = void 0;
var EventTypes;
(function (EventTypes) {
    EventTypes["PriceEvent"] = "PriceEvent";
    EventTypes["SellerPriceDetailsEvent"] = "SellerPriceDetailsEvent";
})(EventTypes || (exports.EventTypes = EventTypes = {}));
var PriceEventActions;
(function (PriceEventActions) {
    PriceEventActions["PriceGet"] = "PriceGet";
    PriceEventActions["PriceCreated"] = "GetPrices";
    PriceEventActions["PriceUpdated"] = "PriceUpdated";
    PriceEventActions["PriceDeleted"] = "PriceDeleted";
    PriceEventActions["GetPrices"] = "GetPrices";
    PriceEventActions["CreatePrice"] = "CreatePrice";
    PriceEventActions["UpdatePrice"] = "UpdatePrice";
    PriceEventActions["DeletePrice"] = "DeletePrice";
})(PriceEventActions || (exports.PriceEventActions = PriceEventActions = {}));
var SellerPriceDetailsEventActions;
(function (SellerPriceDetailsEventActions) {
    SellerPriceDetailsEventActions["SellerPriceDetailGet"] = "SellerPriceDetailGet";
    SellerPriceDetailsEventActions["SellerPriceDetailCreated"] = "GetSellerPriceDetails";
    SellerPriceDetailsEventActions["SellerPriceDetailUpdated"] = "SellerPriceDetailUpdated";
    SellerPriceDetailsEventActions["SellerPriceDetailDeleted"] = "SellerPriceDetailDeleted";
    SellerPriceDetailsEventActions["GetSellerPriceDetails"] = "GetSellerPriceDetails";
    SellerPriceDetailsEventActions["CreateSellerPriceDetail"] = "CreateSellerPriceDetail";
    SellerPriceDetailsEventActions["UpdateSellerPriceDetail"] = "UpdateSellerPriceDetail";
    SellerPriceDetailsEventActions["DeleteSellerPriceDetail"] = "DeleteSellerPriceDetail";
})(SellerPriceDetailsEventActions || (exports.SellerPriceDetailsEventActions = SellerPriceDetailsEventActions = {}));
